import {Box, Button, Tooltip} from "@mantine/core";
import dayjs from "dayjs";
import cx from "clsx";
import classes from "../FocusModeView.module.css";

/**
 * Countdown timer state used by FocusModeView and CountdownDisplay.
 * showHours is decided once when countdown starts so the timer display format
 * stays stable for the entire run:
 * - starts >= 1 hour => HH:mm:ss throughout
 * - starts < 1 hour => mm:ss throughout
 */
export interface CountdownState {
    counting: boolean;
    counter: number;
    showHours: boolean;
    direction: "up" | "down";
    description: string;
}

export const formatCountdownDisplay = (countDownState: CountdownState): string => (
    countDownState.showHours
        ? dayjs.duration(countDownState.counter, "seconds").format("HH:mm:ss")
        : dayjs.duration(countDownState.counter, "seconds").format("mm:ss")
);

interface CountdownDisplayProps {
    countDownState: CountdownState;
    onStop: (state: CountdownState) => void;
    onCancel: () => void;
}

/**
 * Displays the countdown timer with a stop button.
 */
export const CountdownDisplay: React.FC<CountdownDisplayProps> = ({
                                                                      countDownState,
                                                                      onStop,
                                                                      onCancel,
                                                                  }) => {
    const countdownDisplay = formatCountdownDisplay(countDownState)

    const handleStopClick = () => {
        onStop(countDownState);
    };

    const handleCancelClick = () => {
        onCancel();
    };

    return (
        <Box className={cx(classes.countDown)}>
            <Box className={cx(classes.countDownTitle)}>{countDownState.description}</Box>
            <Box className={cx(classes.countDownText)}>
                {countdownDisplay}
            </Box>
            <Box className={cx(classes.countDownButtons)}>
                <Tooltip label={"Cancel the activity."}>
                    <Button bg={"gray"} size={"xs"} onClick={handleCancelClick}>
                        Cancel
                    </Button>
                </Tooltip>
                <Box/>
                <Tooltip label={"End the activity early."}>
                    <Button bg={"red"} size={"xs"} onClick={handleStopClick}>
                        Stop
                    </Button>
                </Tooltip>
            </Box>
        </Box>
    );
};
